import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22index.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../public/statics/fonts/MatterRegular.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22../../public/statics/fonts/MatterRegular.woff%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22../../public/statics/fonts/MatterMedium.woff2%22,%22weight%22:%22500%22,%22style%22:%22normal%22},{%22path%22:%22../../public/statics/fonts/MatterMedium.woff%22,%22weight%22:%22500%22,%22style%22:%22normal%22}],%22variable%22:%22--font-matter-medium%22}],%22variableName%22:%22MatterMedium%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'MatterMedium', 'MatterMedium Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
